<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >{{title}}</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(print)">
          <p class="description">* Silahkan masukan NOP dan Tahun yang ingin dicetak SSPD .</p>
          <div class="mb-5">
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <ValidationProvider name="NOP" rules="required" v-slot="{ errors }">
                  <base-input
                    placeholder="NOP"
                    v-model="form.nop"
                    :required="true"
                    :error="errors[0]"
                    :valid="(errors[0] !== null && errors[0] !== '')"
                  ></base-input>
                </ValidationProvider>
                 <ValidationProvider name="TAHUN" rules="required" v-slot="{ errors }">
                  <base-input
                    placeholder="TAHUN"
                    v-model="form.tahun"
                    :required="true"
                    :error="errors[0]"
                    :valid="(errors[0] !== null && errors[0] !== '')"
                  ></base-input>
                </ValidationProvider>
              </div>
              <div class="col-lg-4 col-sm-6">
                <base-button type="success" nativeType="submit" :disabled="isBusy" icon="ni ni-zoom-split-in">Cetak Data</base-button>
                <template v-if="isBusy">
                  <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                  <strong>Loading...</strong>
                </template>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <hr />
     
    </div>
    <template slot="footer">
      <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { BTable, BTr, BTh } from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import dateToDateHumanize from "@/plugins/dateFormater";
import formatToMoney from "@/plugins/formatToMoney";
import mapInvestigationType from "@/plugins/mapInvestigationType";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import requestpbb from "@/plugins/requestpbb";

export default {
  components: {
    Modal,
    BTable,
    PulseLoader,
    BTr,
    BTh,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal"
    },
    code: {
      type: String,
      description: "Code Pajak"
    },
    url: {
      type: String,
      description: "Url Pajak"
    }
  },
  data() {
    return {
      modals: {
        modal1: false
      },
      form: {
        nop: null,
        tahun: null
      },
      
      items: [],
      isBusy: false
    };
  },
  methods: {
    showModal() {
      this.items = [];
      this.form.nop = "";
      this.form.tahun = "";
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    print() {
      try {
        const me = this;
        this.isBusy = true;
        
        requestpbb({
          url: "/ketapang/informasi/Pbb/report/sspd/"+this.form.nop+"/"+this.form.tahun,
          method: "GET",          
          responseType: "blob",
        })
          .then((response) => {            
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
                this.form.nop +
                "_" +
                this.form.tahun +
                ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.isBusy = false;
          })
          .catch((e) => {
            // console.log(e);
            this.isBusy = false;
          });
      } catch (e) {
        // console.log(e);
        this.isBusy = false;
      }
    },    
  }
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}
</style>